import {knownSpiderMark, pvTypes} from './constant';


export const sourceMap = new Map();
Object.keys(knownSpiderMark).forEach(key => {
    sourceMap.set(key, knownSpiderMark[key]);
});
Object.keys(pvTypes).forEach(key => {
    sourceMap.set(key, pvTypes[key]);
});

export function source2mark(source) {
    return sourceMap.get(source);
}
export const mark2name = mark => {
    mark = parseInt(mark, 10);
    const keys = sourceMap.keys();
    for (let key of keys) {
        const range = sourceMap.get(key);
        if (mark >= range[0] && mark <= range[1]) {
            return key;
        }
    }
    console.log('异常数据：' + mark);
    return '';
};

export const getSourceArray = () => {
    return Object.keys(knownSpiderMark);
}